(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["byob-bundle"] && !Shopify.designMode) return;
  try {
    
  class ByobBundle {
    constructor(root) {
      this.root = root;
      this.size = parseInt(root.dataset.bundleSize, 10) || 3;
      this.variantId = root.dataset.bundleVariant;
      this.selection = [];
      this.trayList = root.querySelector('[data-tray-list]');
      this.trayCount = root.querySelector('[data-tray-count]');
      this.trayHint = root.querySelector('[data-tray-hint]');
      this.submitBtn = root.querySelector('[data-bundle-submit]');
      this.progressNodes = root.querySelectorAll('.byob-progress__node');
      this.progressLines = root.querySelectorAll('.byob-progress__line');
      this.bind();
      this.render();
    }

    bind() {
      this.root.querySelectorAll('[data-add-to-bundle]').forEach((btn) => {
        btn.addEventListener('click', () => this.addCard(btn.closest('.byob-card')));
      });
      this.root.querySelectorAll('[data-size-filter]').forEach((btn) => {
        btn.addEventListener('click', () => this.filter(btn.dataset.sizeFilter, btn));
      });
      this.submitBtn.addEventListener('click', () => this.submit());
    }

    filter(size, btn) {
      this.root.querySelectorAll('[data-size-filter]').forEach((b) => b.classList.remove('is-active'));
      if (btn) btn.classList.add('is-active');
      this.root.querySelectorAll('.byob-card').forEach((card) => {
        const sizes = (card.dataset.sizes || '').split(',').filter(Boolean);
        const show = !size || sizes.includes(size);
        card.hidden = !show;
        const sel = card.querySelector('[data-size-select]');
        if (!sel) return;
        if (show && size) {
          const opt = Array.from(sel.options).find((o) => o.dataset.title === size && !o.disabled);
          if (opt) sel.value = opt.value;
        } else if (!size) {
          sel.value = '';
        }
      });
    }

    addCard(card) {
      if (this.selection.length >= this.size) { this.flashHint(`You can only pick ${this.size}. Remove one first.`); return; }
      const productId = card.dataset.productId;
      if (this.selection.some((s) => s.productId === productId)) { this.flashHint('That dress is already in your bundle.'); return; }
      const select = card.querySelector('[data-size-select]');
      const variantId = select.value;
      if (!variantId) { this.flashHint('Pick a size for that dress first.'); return; }
      const opt = select.options[select.selectedIndex];
      const slide = card.querySelector('.byob-card__slide');
      this.selection.push({
        productId,
        variantId,
        productTitle: card.querySelector('.byob-card__title').textContent.trim(),
        sizeTitle: opt.dataset.title || opt.textContent.trim(),
        price: card.dataset.price || '',
        image: slide ? slide.src : '',
      });
      card.classList.add('is-selected');
      this.render();
    }

    remove(index) {
      const removed = this.selection.splice(index, 1)[0];
      if (removed) {
        const card = this.root.querySelector(`.byob-card[data-product-id="${removed.productId}"]`);
        if (card) card.classList.remove('is-selected');
      }
      this.render();
    }

    render() {
      this.trayCount.textContent = this.selection.length;
      const count = this.selection.length;
      if (this.progressNodes) {
        this.progressNodes.forEach((n) => n.classList.toggle('is-on', count >= parseInt(n.dataset.node, 10)));
      }
      if (this.progressLines) {
        this.progressLines.forEach((l) => l.classList.toggle('is-on', count >= parseInt(l.dataset.line, 10)));
      }
      this.trayList.innerHTML = '';
      this.selection.forEach((item, i) => {
        const li = document.createElement('li');
        li.className = 'byob-tray__item';

        const thumb = document.createElement('img');
        thumb.className = 'byob-tray__thumb';
        thumb.src = item.image || '';
        thumb.alt = '';
        thumb.loading = 'lazy';

        const details = document.createElement('div');
        details.className = 'byob-tray__details';

        const name = document.createElement('span');
        name.className = 'byob-tray__item-name';
        name.textContent = `${item.productTitle} - ${item.sizeTitle}`;

        const price = document.createElement('span');
        price.className = 'byob-tray__item-price';
        price.innerHTML = `<s>${item.price}</s><b>$0.00</b>`;

        details.append(name, price);

        const rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'byob-tray__remove';
        rm.textContent = 'Remove';
        rm.addEventListener('click', () => this.remove(i));

        li.append(thumb, details, rm);
        this.trayList.appendChild(li);
      });
      const full = this.selection.length === this.size;
      this.submitBtn.disabled = !full;
      if (this.trayHint) {
        this.trayHint.textContent = full
          ? 'Ready! Add your bundle to cart.'
          : `Add ${this.size - this.selection.length} more dress${this.size - this.selection.length === 1 ? '' : 'es'} to continue.`;
      }
    }

    flashHint(msg) { if (!this.trayHint) return; this.trayHint.textContent = msg; }

    async submit() {
      if (this.selection.length !== this.size) return;
      this.submitBtn.disabled = true;
      this.submitBtn.textContent = 'Adding...';
      const properties = {};
      this.selection.forEach((item, i) => {
        properties[`Dress ${i + 1}`] = `${item.productTitle} - ${item.sizeTitle}`;
        properties[`_dress_${i + 1}_variant`] = item.variantId;
      });
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(this.variantId), quantity: 1, properties }] }),
        });
        if (!res.ok) throw new Error(await res.text());
        window.location.href = '/cart';
      } catch (err) {
        this.submitBtn.disabled = false;
        this.submitBtn.textContent = 'Add bundle to cart';
        this.flashHint('Could not add the bundle. Please try again.');
        console.error('BYOB add failed', err);
      }
    }
  }

  document.querySelectorAll('[data-byob]').forEach((el) => new ByobBundle(el));

  document.querySelectorAll('[data-byob-gallery]').forEach((track) => {
    const dotsWrap = track.parentElement.querySelector('[data-byob-dots]');
    if (!dotsWrap) return;
    const dots = dotsWrap.querySelectorAll('.byob-card__dot');
    let raf = null;
    track.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        const i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
      });
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { 
      super();  
    }
    
    connectedCallback() {      
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};  
      this.setHeaderHeight(); 
      window.matchMedia('(max-width: 1090px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);   

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {   
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }
      
    hide() {
      if (this.headerIsAlwaysSticky) return;   
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');    
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();
})();
